import { Injector } from '@angular/core';

import { RuntimeConfigService } from '../../../../../app/services/runtime-config';
import { payload_static } from './payload-helper';
import {
  secName,
  TAdobeLaunchPayload,
  TAdobeLaunchPayloadDynamic,
  TEventType,
  TFormSubmissionStatus,
  TttMETA,
} from './types';

declare global {
  interface Window {
    cacAnalytics: any;
    adobeDataLayer: any;
    ttMETA: TttMETA[];
    ttMETAstarttime: number | null;
  }
}

const singleEvents = {
  'cac-form-start': true,
  'cac-page-view-personal': true,
  'cac-page-view-residence': true,
  'cac-page-view-income': true,
  'cac-page-view-accounts': true,
  'cac-page-view-identification': true,
  'cac-page-view-summary': true,
};

class AdobeAnalytics {
  initted = false;
  isLoaded = false;
  startEvent = false;
  eventsMap = new Map<string, number>();
  initTime = 0;
  runtimeConfigService: RuntimeConfigService;
  emitFromStart: boolean = false;
  constructor(private injector: Injector) {
    this.initTime = new Date().getTime();
    this.runtimeConfigService = this.injector.get(RuntimeConfigService);
  }

  init(cb: (x: boolean, lt: number) => void) {
    // just to make sure we don't initiate more than once by mistake injecting the same script
    if (!this.initted) {
      this.initted = true;
      if (!window['cacAnalytics']) {
        window['cacAnalytics'] = {};
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = this.runtimeConfigService.prequalConfig.ADOBE_SCRIPT_URL;
      script.async = false;
      script.onload = () => {
        this.isLoaded = true;
        const loadTime = new Date().getTime() - this.initTime;
        cb(this.isLoaded, loadTime);
      };
      document.getElementsByTagName('head')[0].appendChild(script);

      const footerScript = document.createElement('script');
      footerScript.type = 'text/javascript';
      footerScript.appendChild(
        document.createTextNode(`if(typeof _satellite != "undefined") {
        _satellite.pageBottom();
      } `)
      );
      document.body.appendChild(footerScript);
    }
  }

  get loadedStatus() {
    return this.isLoaded;
  }

  emitFormStart(secName: secName) {
    if (!this.startEvent) {
      this.startEvent = true;
      adobeAnalytics.emitEvent('cac-form-start', null, {
        form_design: 'v 1.0',
        section_name: secName,
        form_submission_id: '',
        dealer_list: '',
        form_submission_status: '',
        event_type: 'cac-form-start',
      });
    }
  }

  emitEvent(
    type: TEventType,
    step: string | null,
    payload: TAdobeLaunchPayloadDynamic
  ) {
    const formattedStep = step ? `-${step}` : '';
    if (
      singleEvents[(type + formattedStep) as keyof typeof singleEvents] &&
      this.eventsMap.has(type + formattedStep)
    ) {
      // if a one-time event has been emitted - return
      return;
    } else if (
      singleEvents[(type + formattedStep) as keyof typeof singleEvents]
    ) {
      // otherwise add it to the map
      this.eventsMap.set(type + formattedStep, 1);
    }
    // process the event
    const cacAnalytics: {
      page_url: 'https://www.creditacceptance.com/get-prequalified/' | string;
      max_monthly_payment_amount?: number;
      account_type: '';
      dealer_list: string;
      form_submission_id: string;
      page_title: 'pre-qualify for car financing in minutes';
      form_type: 'pre-qualify';
      web_lang: 'en-us';
      event_type: TEventType;
      sub_property: '';
      property: 'www';
      form_submission_status: TFormSubmissionStatus;
      test_response?: string;
      event:
        | 'cac-page-view'
        | 'cac-form-start'
        | 'cac-form-complete'
        | 'cac-save-me-time';
      br_language: 'en-us';
      is_spa: true;
      signed_in_status: 'guest';
      section_name: string;
      sub_sub_property: 'pre-qualify for car financing in minutes';
      form_name_id: 'marketplace_lf';
      form_design: string;
      min_down_payment_amount?: number;
      form_failure_reason?: string;
      test_experience?: string;
      test_name?: string;
      max_finance_amount?: number;
      user_id?: string;
    } = {
      ...payload_static,
      ...payload,
      event: payload.event_type,
    };
    window.adobeDataLayer && window.adobeDataLayer.push(cacAnalytics);
  }
}

export const adobeAnalytics = new AdobeAnalytics(
  Injector.create({
    providers: [{ provide: RuntimeConfigService, deps: [Injector] }],
    parent: undefined,
  })
);
